import { createContext as e, useContext as t } from "react";
//#region src/hooks/component-analytics-context.tsx
var n = e(null), r = () => t(n), i = n.Provider;
//#endregion
export { i as ComponentAnalyticsProvider, r as useComponentAnalytics };
